import React from "react";
import { getPreviousPeriodDateRange, formatDisplayDate } from "../../utils/analytics";

type PopPeriodBannerProps = {
    startDate: string;
    endDate: string;
};

const PopPeriodBanner: React.FC<PopPeriodBannerProps> = ({ startDate, endDate }) => {
    const { previousStartDate, previousEndDate, periodDays } = getPreviousPeriodDateRange(startDate, endDate);

    return (
        <div
            style={{
                fontSize: "12px",
                color: "#28a745",
                marginTop: "0px",
                marginBottom: "4px",
                padding: "4px 0"
            }}
        >
            PoP deltas for metrics compare the period{" "}
            <strong>{formatDisplayDate(startDate)}</strong>
            {" "}to{" "}
            <strong>{formatDisplayDate(endDate)}</strong>
            {" "}against{" "}
            <strong>{formatDisplayDate(previousStartDate)}</strong>
            {" "}to{" "}
            <strong>{formatDisplayDate(previousEndDate)}</strong>
            {" "}({periodDays}d)
        </div>
    );
};

export default PopPeriodBanner;
